function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

import React, { useState } from "react";
import PropTypes from "prop-types";
import { nanoid } from "nanoid";
import useTheme from "../../hooks/useTheme";
import useBackground from "../../hooks/useBackground";
import useResponsivePropsCSS from "../../hooks/useResponsivePropsCSS";
import Grid from "../Grid";
import VisuallyHidden from "../VisuallyHidden";
import { jsx as ___EmotionJSX } from "@emotion/core";
var COLORS = ["grey.t05", "white"];
var DEFAULT_PROPS = {
  color: "grey.t05",
  disabled: false,
  isValid: true
};
InternalRadioGroup.COLORS = COLORS;
InternalRadioGroup.DEFAULT_PROPS = DEFAULT_PROPS;

function RadioCircle(props) {
  var isChecked = props.isChecked;
  var theme = useTheme();

  var _useBackground = useBackground(),
      inputColorMap = _useBackground.inputColorMap;

  var outerCircleCSS = useResponsivePropsCSS(props, {}, {
    color: function color(propsAtBreakpoint, theme, bp) {
      var _props$color;

      return theme.radioGroup.getCSS({
        targetElement: "outerCircle",
        color: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : inputColorMap[bp],
        isChecked: isChecked
      });
    }
  });
  return ___EmotionJSX("svg", {
    css: theme.radioGroup.getCSS({
      targetElement: "circleSvg"
    }),
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, ___EmotionJSX("circle", {
    css: outerCircleCSS,
    cx: "12",
    cy: "12",
    r: "12"
  }), isChecked && ___EmotionJSX("circle", {
    css: theme.radioGroup.getCSS({
      targetElement: "innerCircle"
    }),
    cx: "12",
    cy: "12",
    r: "6"
  }));
}

RadioCircle.propTypes = {
  color: PropTypes.oneOf(["white", "secondary.lightBlue.t25"]),
  isChecked: PropTypes.bool.isRequired
};

function Radio(props) {
  var name = props.name,
      parentName = props.parentName,
      label = props.label,
      isLabelBold = props.isLabelBold,
      description = props.description,
      isChecked = props.isChecked,
      disabled = props.disabled,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      onMouseDown = props.onMouseDown,
      value = props.value,
      onChange = props.onChange;
  var theme = useTheme();

  var _useBackground2 = useBackground(),
      inputColorMap = _useBackground2.inputColorMap;

  var labelCSS = useResponsivePropsCSS(props, DEFAULT_PROPS, {
    color: function color(propsAtBreakpoint, theme, bp) {
      var _props$color2;

      return theme.radioGroup.getCSS({
        targetElement: "radioLabel",
        color: (_props$color2 = props.color) !== null && _props$color2 !== void 0 ? _props$color2 : inputColorMap[bp]
      });
    }
  });

  var _useState = useState(function () {
    return "radio-input-".concat(nanoid());
  }),
      _useState2 = _slicedToArray(_useState, 1),
      inputId = _useState2[0];

  return ___EmotionJSX("div", {
    css: theme.radioGroup.getCSS({
      targetElement: "radio"
    }),
    role: "radio",
    "aria-checked": isChecked
  }, ___EmotionJSX(VisuallyHidden, null, ___EmotionJSX("input", {
    css: theme.radioGroup.getCSS({
      targetElement: "radioInput"
    }),
    type: "radio",
    id: inputId,
    name: name,
    "data-parent-name": parentName,
    value: value,
    checked: isChecked,
    disabled: disabled,
    onFocus: onFocus,
    onBlur: onBlur,
    onChange: onChange
  })), ___EmotionJSX("label", {
    css: labelCSS,
    htmlFor: inputId,
    onMouseDown: onMouseDown
  }, ___EmotionJSX(RadioCircle, {
    color: props.color,
    isChecked: isChecked
  }), ___EmotionJSX("div", null, isLabelBold ? ___EmotionJSX("strong", null, label) : label, description ? ___EmotionJSX("div", {
    css: theme.radioGroup.getCSS({
      targetElement: "description"
    })
  }, description) : null)));
}

Radio.propTypes = {
  name: PropTypes.string.isRequired,
  parentName: PropTypes.string,
  color: PropTypes.oneOf(COLORS),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  isLabelBold: PropTypes.bool.isRequired,
  description: PropTypes.node,
  isChecked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  onFocus: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  onMouseDown: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

function InternalRadioGroup(_props) {
  var props = _objectSpread(_objectSpread({}, DEFAULT_PROPS), _props);

  var name = props.name,
      parentName = props.parentName,
      labelId = props.labelId,
      options = props.options,
      columns = props.columns,
      color = props.color,
      disabled = props.disabled,
      isValid = props.isValid,
      describedBy = props.describedBy,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      onMouseDown = props.onMouseDown,
      checkedValue = props.value,
      onChange = props.onChange;
  var cols = columns === undefined ? options.length : columns;
  var areLabelsBold = options.some(function (option) {
    return option.description;
  });
  return ___EmotionJSX("div", {
    role: "radiogroup",
    "aria-invalid": isValid ? null : "true",
    "aria-labelledby": labelId,
    "aria-describedby": describedBy
  }, ___EmotionJSX(Grid, {
    cols: cols,
    colsGap: 1,
    rowsGap: 1
  }, options.map(function (_ref, index) {
    var label = _ref.label,
        description = _ref.description,
        value = _ref.value;
    return ___EmotionJSX(Grid.Item, {
      colSpan: index % cols,
      rowSpan: Math.floor(index / cols),
      key: value
    }, ___EmotionJSX(Radio, {
      name: name,
      parentName: parentName,
      color: color,
      label: label,
      isLabelBold: areLabelsBold,
      description: description,
      value: value,
      isChecked: value === checkedValue,
      disabled: disabled,
      onFocus: onFocus,
      onBlur: onBlur,
      onMouseDown: onMouseDown,
      onChange: onChange
    }));
  })));
}

InternalRadioGroup.propTypes = {
  name: PropTypes.string.isRequired,
  parentName: PropTypes.string,
  labelId: PropTypes.string,
  options: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    description: PropTypes.node,
    value: PropTypes.string.isRequired
  })), PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.node.isRequired,
    value: PropTypes.string.isRequired
  }))]).isRequired,
  columns: PropTypes.number,
  color: PropTypes.oneOf(COLORS),
  disabled: PropTypes.bool,
  isValid: PropTypes.bool,
  describedBy: PropTypes.string,
  onFocus: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  onMouseDown: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};
export default InternalRadioGroup;